import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as Constants from './constants'
import * as brActions from './actions'
const getProductsState = state => state.products;
import { queryEncoding } from '../../lib/common'

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}


function handleFileRequest(request) {
  return request
    .then(function (response) {
      return {
        data: response.data
      };
    })
    .catch((error) => { throw error })
}

function listRequestApi(formData) {
  const request = axiosApi().post(
    Constants.PRODUCTS_LIST_API,
    formData
  )

  return handleRequest(request);
}

function detailRequestApi(formData) {
  const request = axiosApi().post(
    Constants.PRODUCTS_DETAIL_API,
    formData
  )

  return handleRequest(request);
}

function productsUpdateRequestApi(formData) {
  const request = axiosApi().post(
    Constants.PRODUCTS_UPDATE_API,
    formData
  )

  return handleRequest(request);
}

function* productsListRequestFlow() {
  const products = yield select(getProductsState);
  try {
    // grab the client from our action
    const results = yield call(listRequestApi, products.formData)

    // dispatch the action with our widgets!
    yield put(brActions.productsListSuccess(results.data))

  } catch (error) {
    yield put(brActions.productsListError(error))
  }
}

function* productsDetailRequestFlow() {
  const products = yield select(getProductsState);
  try {
    // grab the client from our action
    const results = yield call(detailRequestApi, products.formData)

    // dispatch the action with our widgets!
    yield put(brActions.productsDetailSuccess(results.data))

  } catch (error) {
    yield put(brActions.productsDetailError(error))
  }
}

function* productsUpdateRequestFlow(action) {
  const products = yield select(getProductsState);
  try {
    // grab the client from our action
    const result = yield call(productsUpdateRequestApi, products.formData)

    // dispatch the action with our widgets!
    yield put(brActions.productsUpdateSuccess(result));
  } catch (error) {
    yield put(brActions.productsUpdateError(error))
  }
}
function productsRemoveRequestApi(formData) {
  const request = axiosApi().post(
    Constants.PRODUCTS_REMOVE_API,
    formData
  )

  return handleRequest(request);
}

function* productsRemoveRequestFlow({ payload }) {
  try {
    // grab the client from our action
    const result = yield call(productsRemoveRequestApi, payload)
    if (result.code != 200) {
      yield put(brActions.productsRemoveError(result.message))
    } else {
      // dispatch the action with our widgets!
      yield put(brActions.productsRemoveSuccess(result));
    }
  } catch (error) {
    yield put(brActions.productsRemoveError(error))
  }
}

function exportXlsRequestApi(formData) {
  const url = Constants.PRODUCTS_EXPORT_XLS_API + "?" + queryEncoding(formData)
  const request = axiosApi().get(
    url,
    {
      responseType: 'blob'
    }
  );

  return handleFileRequest(request);
}

function* productsExportXlsRequestFlow(action) {
  try {
    const { formData, callback } = action
    // grab the client from our action
    const results = yield call(exportXlsRequestApi, formData)
    // dispatch the action with our widgets!
    yield put(brActions.productsExportXlsSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(brActions.productsExportXlsError(error))
  }
}

function* productsWatcher() {
  yield [
    takeLatest(Constants.PRODUCTS_LIST_REQUESTING, productsListRequestFlow),
    takeLatest(Constants.PRODUCTS_DETAIL_REQUESTING, productsDetailRequestFlow),
    takeLatest(Constants.PRODUCTS_UPDATE_REQUESTING, productsUpdateRequestFlow),
    takeLatest(Constants.PRODUCTS_REMOVE_REQUESTING, productsRemoveRequestFlow),
    takeLatest(Constants.PRODUCTS_EXPORT_XLS_REQUESTING, productsExportXlsRequestFlow),
  ]
}

export default productsWatcher



// WEBPACK FOOTER //
// ./src/views/Products/sagas.js